module.exports = __webpack_public_path__ + "img/back.c4a70136.svg";